/*  意大利语包  */
import itLocale from 'element-ui/lib/locale/lang/it'
const ydly = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Disco cloud',
        'headerlangSelect' : 'Por favor selecione um idioma',
        'headerLoginOut' : 'Sair',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Seleziona una lingua',
        'sideMenuPhoto' : 'immagine',
        'sideMunsDoc' : 'file',
        'sideMenuVideo' : 'video',
        'sideMenuSeed' : 'seme',
        'sideMenuMusic' : 'musica',
        'sideMenuOrther' : 'altro',
        'sideMenuShareName' : 'La mia parte',
        'sideMenuCollectName' : 'Cestino',

        /*  用户语言设定 */
        'mainUpload' : 'Carica',
        'mainBuildDir' : 'Nuova cartella',
        'mainDownloadOutline' : 'Scarica offline',
        'mainSearch' : 'Ricerca file',
        'mainAllFile' : 'Tutti i file',
        'mainFile' : 'file',
        'mainSize' : 'dimensione',
        'mainDate' : 'data',
        'mainFileDel' : 'Elimina',
        'mainConfirmDel' : 'Conferma l\'eliminazione?',
        'sure' : 'Conferma',
        'cancel' : 'annullato',
        'mainReturn' : 'Torna a',
        'mainPagePrev' : 'precedente',
        'mainPageNext' : 'Pagina successiva',
        'mainLoaded' : 'caricato',
        'mainTotal' : 'totale',
        'mainUnit' : 'articolo',
        'dilatation' : 'espansione',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Suggerimento: il cestino non occupa spazio sul disco di rete.',
        'mainHeaderButton' : 'Svuota cestino',
        'collectName' : 'Cestino',
        'mainRevertIts' : 'riduzione',
        'mianDelData' : 'Elimina tempo',

        'confirmClear' : 'Conferma per cancellare i file selezionati? (Impossibile ripristinare dopo la cancellazione)',
        'confirmClearAll' : 'Sei sicuro di voler svuotare il cestino?',

        /*  其他设定 */
        'messageBoxTitle' : 'sollecito',
        'messageBoxConfirmRevert' : 'Conferma di ripristinare il file selezionato?',
        'loading' : 'Caricamento in corso ...',
        'loaded' : 'Nessun dato',

        'messageMoveTo' : 'Sposta in',
        'filterNotice' : 'Inserisci le parole chiave da filtrare',
        'messageLoaded' : 'scaricato:',
        'messageMovetion' : 'Sposta file',

        'messageMissKeyWord' : 'Inserisci le parole chiave per la ricerca',
        'messageFolderLayersLimit' : 'Creazione non riuscita La profondità della gerarchia di cartelle non supera i 5 livelli',
        'messageSameFolderName' : 'Creazione non riuscita Lo stesso nome file esiste',
        'messageEmptyFolderName' : 'Inserisci un nome per la cartella',
        'messageMoveSame' : 'Impossibile spostare nella stessa cartella',
        'messageActionError' : 'Operazione fallita',
        'messageActionSuccess' : 'Operazione riuscita',
        'messageServerIsBusy' : 'Il server è occupato',
        'messageUploadOverLimit' : 'Troppi file selezionati (entro 5)',
        'messageDiskFreeFull' : 'Spazio utente insufficiente',
        'messageUploadTypeError' : 'Impossibile caricare questo tipo di file',
        'messageUploadMaxSize' : 'Il file di caricamento è troppo grande (entro 10 M)',
        'messageUploadSuccess' : 'Caricato correttamente',
        'messageUploadFailed' : 'Caricamento non riuscito',
        'messageDownloadFailed' : 'Download fallito'
    },
    ...itLocale
};

export default ydly;



// WEBPACK FOOTER //
// ./src/i18n/langs/ydly.js